import { createSelector } from 'reselect';
import { subselect } from './root';

export const scoreSelector = createSelector([(trivia) => trivia.score], (value) => value || 0);

export const triviaScoreSelector = subselect(scoreSelector);
